const regSymbolRu = /^[А-ЯЁа-яёA-Za-z\s]|-+$/
const regSymbolEn = /^[A-Za-z\s]|-+$/
const regStringRu = /^[а-яёA-Za-z]+(?:[ -]{1}[а-яёA-Za-z]*)?$/i
const regStringEn = /^[a-z]+(?:[ -]{1}[a-z]*)?$/i

const EventTypes = {
  keypress: (e) => {
    return {
      char: String.fromCharCode(e.keyCode),
      reg: regSymbolRu,
      regEn: regSymbolEn
    };
  },
  paste: (e) => {
    return {
      char: (e.clipboardData || window.clipboardData).getData("text"),
      reg: regStringRu,
      regEn: regStringEn,
    }
  },
  default: (e) => {
    return {
      char: e.target.value,
      reg: regStringRu,
      regEn: regStringEn,
    }
  }
}

export function isLetter(e, withCyrillic = false) {
  const { char, reg, regEn } = Object.hasOwn(EventTypes, e?.type) ? EventTypes[e.type](e) : EventTypes.default(e);
  const re = withCyrillic ? reg : regEn;

  if (re.test(char)) return true;
  else e.preventDefault();
}
